import { AppRoutes } from "./router";
import { BrowserRouter } from "react-router-dom";
import { shouldUseMobileLayout } from "./utils/deviceDetection";
import { useState, useEffect } from "react";
import { AuthProvider } from "./contexts/AuthContext";
import { CartProvider } from "./contexts/CartContext";
import AuthModal from "./components/feature/AuthModal";
import FloatingWhatsAppButton from "./components/feature/FloatingWhatsAppButton";
import ErrorBoundary from "./components/ErrorBoundary";

function App() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(shouldUseMobileLayout());
    
    const handleResize = () => {
      setIsMobile(shouldUseMobileLayout());
    };
    
    window.addEventListener('resize', handleResize);
    
    // Cleanup adequado do event listener
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    // Define variável global para mobile
    (window as Window & { __IS_MOBILE_APP__?: boolean }).__IS_MOBILE_APP__ = isMobile;
  }, [isMobile]);

  return (
    <ErrorBoundary>
      <BrowserRouter basename={__BASE_PATH__}>
        <AuthProvider>
          <CartProvider>
            <AppRoutes />
            <AuthModal />
            <FloatingWhatsAppButton />
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;